export const ChainOptions = [
  { id: 'ethereum', name: 'ETHEREUM', image: '/assets/tokens/ETHIcon.svg' },
  { id: 'solana', name: 'SOLANA', image: '/assets/tokens/solanaIcon.svg' },
  { id: 'binance', name: 'BINANCE', image: '/assets/logo/BNB22.svg' },
  // { id: 'tezos', name: 'TEZOS', image: '/assets/tezosIcon.svg' },
  // { id: 'immutablex', name: 'IMMUTABLE X', image: '/assets/immutablexIcon.svg' },
  // { id: 'flow', name: 'FLOW', image: '/assets/flowIcon.svg' },
  { id: 'polygon', name: 'POLYGON', image: '/assets/tokens/polygonIcon.svg' },
];

export const TOOLTIP_TOKEN_FIXED_DECIMAL = 4;

export enum MODULE_TYPES {
  API = 'API',
  ETHERS = 'ETHERS',
  WS = 'Websockets',
}
